import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import { TimerDriverOnTime } from './TimerDriverOnTime';
import earlyImage from '../../../assets/images/driver-arrived-early.png';
import { t } from '../../../services/translation/translation';

type Props = {
  trip: TripOutput;
};
export const DriverInPlace = ({ trip }: Props) => {
  if (!trip.tripVars.flash && trip.resume.departureAt > Date.now()) {
    return (
      <div className="flex justify-between items-center gap-x-2">
        <div className="flex-col flex w-full flex-1">
          <strong>{t('share-route.trip-detail.title-early')}</strong>
          <span>{t('share-route.trip-detail.subtitle-early')}</span>
        </div>
        <img alt="early" className="h-16" src={earlyImage} />
      </div>
    );
  }
  return <TimerDriverOnTime trip={trip} />;
};
